import { Language } from '@penta/i18n-init';

export const formatLanguageToLocaleRegion = (lang: string): Language => {
  // If it's already a valid Language enum value, return it
  if (Object.values(Language).includes(lang as Language)) {
    return lang as Language;
  }

  // Extract the short prefix (handles basic 'cs', 'cs-CZ', 'cs_CZ')
  const shortLang = lang.split(/[-_]/)[0];
  switch (shortLang) {
    case 'cs':
      return Language.CS;
    case 'sk':
      return Language.SK;
    case 'en':
      return Language.EN;
    default:
      return Language.CS;
  }
};

export const formatLocaleRegionToLanguage = (localeRegion: string): string => {
  return localeRegion.split(/[-_]/)[0];
};
